import React from "react";

import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Theme } from "@material-ui/core/styles";
import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import Breakpoints from "common/breakpoints";
import Donut from "components/Charts/Donut";
import { differenceInDaysOrNA } from "utils/date-utils";
import ExamRequirementStatus from "./ExamRequirementStatus";
import { examTypeLabels, THOUSAND_LIMIT } from "./options";
import ExternalExamFormLinks from "./ExternalExamFormLinks";
import MobileDefaultExamRequirement from "./MobileDefaultExamRequirement";

import useStyles from "./styles";

interface Props {
  examRequirement: racehorse360.IHorseExamRequirement;
  onExamRequirementUpdate: (
    id: string,
    patch: racehorse360.IHorseExamRequirement
  ) => void;
}

const DefaultExamRequirement = ({
  examRequirement,
  onExamRequirementUpdate
}: Props) => {
  const classes = useStyles();

  const matchesDownSX720 = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down(Breakpoints.SX_720)
  );

  const widgetValue = Number(
    differenceInDaysOrNA(examRequirement.horse.lastRaceDate)
  );
  const customWidgetValue = widgetValue >= THOUSAND_LIMIT ? "1K+" : null;

  const daysOff = Number(differenceInDaysOrNA(examRequirement.baseEventDate));
  const examLabel = `${daysOff} ${examTypeLabels[examRequirement.type.code]}`;

  if (matchesDownSX720) {
    return (
      <MobileDefaultExamRequirement
        examRequirement={examRequirement}
        value={widgetValue}
        daysOff={daysOff}
        onExamRequirementUpdate={onExamRequirementUpdate}
      />
    );
  }

  return (
    <div className={classes.root}>
      <div className={classes.leftSideContent}>
        <div className={classes.donutWrapper}>
          <Donut
            className={classes.donut}
            customValue={customWidgetValue}
            value={widgetValue}
            capacity={0}
          />
        </div>
        <div>
          <div className={classes.horseName}>{examRequirement.horse.name}</div>
          <div className={classes.horseExamInfo}>
            <span>{examLabel}</span>
            <ExternalExamFormLinks
              examRequirementTypeCode={examRequirement.type.code}
            />
          </div>
        </div>
      </div>
      <ExamRequirementStatus
        examRequirement={examRequirement}
        onExamRequirementUpdate={onExamRequirementUpdate}
      />
    </div>
  );
};

export default React.memo(DefaultExamRequirement);
